// REACT
import * as React from 'react';

// REDUX
import { connect } from 'react-redux';
import * as actions from '../actions';

// ROUTER
import { withRouter } from 'react-router-dom';

// ROUTES
import ConsumerRoutes from './ConsumerRoutes';
import ProviderRoutes from './ProviderRoutes';
import SpecialRoutes from './SpecialRoutes';
import AccountActivationRoutes from './AccountActivationRoutes';

interface DispatchProps {}

interface ComponentProps {}

interface StateProps {
    userId?: string;
    userData?: UserData;
    emailVerified?: boolean;
    signinTokenIsValid?: boolean;
}

// THIS IS BEST MOVED TO A SEPARATE TYPES DEFINITION FILE CO-LOCATED WITH OTHER DATABASE/STATE TYPES
interface UserData {
    provider?: boolean;
    roles?: RoleTypes;
}

// THIS IS BEST MOVED TO A SEPARATE TYPES DEFINITION FILE CO-LOCATED WITH OTHER DATABASE/STATE TYPES
interface RoleTypes {
    superUser?: boolean;
    provider?: boolean;
    staffAdmin?: boolean;
    accountAdmin?: boolean;
}

class Routes extends React.Component<ComponentProps & StateProps, {}> {
    render() {
        const {
            userData,
            userId,
            emailVerified,
            signinTokenIsValid,
        } = this.props;
        const isSuperUser =
            userData && userData.roles && userData.roles.superUser;
        const isProvider = userData && userData.provider;
        return (
            <React.Fragment>
                <AccountActivationRoutes />
                {userData && userData.roles && userData.roles.superUser && (
                    <SpecialRoutes />
                )}
                {((!isProvider && !isSuperUser) ||
                    (!userId && !emailVerified)) && (
                    <ConsumerRoutes
                        userId={userId}
                        emailVerified={emailVerified}
                    />
                )}
                {!signinTokenIsValid &&
                    userId &&
                    emailVerified &&
                    userData &&
                    userData.provider && <ProviderRoutes />}
            </React.Fragment>
        );
    }
}

const mapStateToProps = ({ auth, client }) => ({
    userData: client.clientData,
    emailVerified: auth.authData.emailVerified,
    userId: auth.authData ? auth.authData.id : null,
    signinTokenIsValid: auth.signinTokenIsValid,
});

export default withRouter(
    connect<StateProps, DispatchProps>(
        mapStateToProps,
        actions,
    )(Routes),
);



// WEBPACK FOOTER //
// ./src/js/routes/index.tsx